import * as L from 'leaflet';
export default function LocalizationDrawGeozones() {
    L.EditToolbar.Delete.include({
        removeAllLayers: false,
    });
    //////// Подсказки к кнопкам //////////////
    // Создание;
    L.drawLocal.draw.toolbar.buttons.polyline = 'Создать линию';
    L.drawLocal.draw.toolbar.buttons.polygon = 'Создать полигон';
    L.drawLocal.draw.toolbar.buttons.circle = 'Создать круг';
    //Редактирование
    L.drawLocal.edit.toolbar.buttons.edit = 'Редактировать геозоны';
    L.drawLocal.edit.toolbar.buttons.editDisabled = 'Ещё не создано ни одной геозоны';
    L.drawLocal.edit.toolbar.buttons.remove = 'Удалить геозоны';
    L.drawLocal.edit.toolbar.buttons.removeDisabled =
        'Ещё не создано ни одной  геозоны';
    ////////// Подсказки к действиям //////////////
    //Создание
    L.drawLocal.draw.toolbar.actions.title = 'Отменить создание';
    L.drawLocal.draw.toolbar.actions.text = 'Отмена';
    L.drawLocal.draw.toolbar.finish.title = 'Закончить создание';
    L.drawLocal.draw.toolbar.finish.text = 'Завершить';
    L.drawLocal.draw.toolbar.undo.title = 'Удалить последнюю нарисованную точку';
    L.drawLocal.draw.toolbar.undo.text = 'Удалить последнюю точку';
    //Редактирование
    L.drawLocal.edit.toolbar.actions.save.title = 'Сохранить изменения';
    L.drawLocal.edit.toolbar.actions.save.text = 'Сохранить';
    L.drawLocal.edit.toolbar.actions.cancel.title = 'Отменить все изменения';
    L.drawLocal.edit.toolbar.actions.cancel.text = 'Отмена';
    L.drawLocal.edit.toolbar.actions.clearAll.title = 'Удалить все геозоны';
    L.drawLocal.edit.toolbar.actions.clearAll.text = 'Удалить всё';
    ////////// Подсказки к курсору //////////////
    //Создание
    L.drawLocal.draw.handlers.circle.tooltip.start =
        'Нажмите и ведите, чтобы создать круг';
    L.drawLocal.draw.handlers.circle.radius = 'Радиус';
    L.drawLocal.draw.handlers.polygon.tooltip.start =
        'Нажмите, чтобы начать создавать полигон';
    L.drawLocal.draw.handlers.polygon.tooltip.cont =
        'Нажмите, чтобы продолжить создавать полигон';
    L.drawLocal.draw.handlers.polygon.tooltip.end =
        'Нажмите на первую точку, чтобы закончить создавать полигон';
    L.drawLocal.draw.handlers.polyline.tooltip.start =
        'Нажмите, чтобы начать создавать линию';
    L.drawLocal.draw.handlers.polyline.tooltip.cont =
        'Нажмите, чтобы продолжить создавать линию';
    L.drawLocal.draw.handlers.polyline.tooltip.end =
        'Нажмите на первую точку, чтобы закончить создавать линию';
    L.drawLocal.draw.handlers.polyline.error =
        '<strong>Ошибка:</strong> края линии не должны пересекаться!';
    //Ко всем
    L.drawLocal.draw.handlers.simpleshape.tooltip.end =
        'Уберите мышь, чтобы закончить создание';
    //Редактирование
    L.drawLocal.edit.handlers.edit.tooltip.text =
        'Тащите за квадратик, чтобы изменить геозону';
    L.drawLocal.edit.handlers.edit.tooltip.subtext =
        'Нажмите на отмену, чтобы отменить изменения';
    L.drawLocal.edit.handlers.remove.tooltip.text =
        'Нажмите на геозону, чтобы её удалить';
}
